import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index.js'
import scrollTo from './directives/scrollTo.js'

router.beforeEach((to, from, next) => {
    if (to.path === '/') {
        document.body.className = 'body-home';
    } else if (to.path === '/game-intro') {
        document.body.className = 'body-other body-game-intro';
    } else {
        document.body.className = 'body-other';
    }
    next();
})

const app = createApp(App)

app.directive('scroll-to', scrollTo)
app.use(router)
app.mount('#app')
